export default {
    verja: {
        IS_EMPTY: 'This field is required',
        NO_EMAIL_ADDRESS: 'Invalid email address',
        NOT_EQUAL: 'Values do not match',
        REQUIRED: 'This field is required',
        PASSWORD_TOO_WEAK: 'Password is too weak',
        EMAIL_EXISTS: 'Email already in use',
        STRLEN_TOO_SHORT: 'At least {min} characters required',
        STRLEN_TOO_LONG: 'At most {max} characters required',
    },
    auth: {
        nameInvalid: 'Name can only contain letters, spaces, fullstops and dashes',
        error: {
            'invalid-email-or-password': 'Login failed: invalid email or password',
            'too-many-requests': 'Too many requests. Wait a few minutes and try again',
            'validation-of-user-registration-data-failed': 'Registration failed: invalid user data',
        },
    },
}
